import { CapacitorCookies } from "@capacitor/core";
import storage from "@/utils/storage";

export async function resetApplication() {
  localStorage.clear();
  await CapacitorCookies.clearAllCookies();
  await storage.clear();
  await storage.deleteDatabase();
  window.location.reload();
}
